import { QUERY_KEYS } from '@/constants/query-keys';

export interface QuickCreateConfigItem {
  importForm: () => Promise<any>;
  componentName?: string; // Default is 'default'
  endpoint: string;
}

export const QUICK_CREATE_CONFIGS: Record<string, QuickCreateConfigItem> = {
  [QUERY_KEYS.DICH_VU]: {
    importForm: () => import('@/features/danh-muc/doi-tuong/dich-vu/components/service-dialog'),
    endpoint: QUERY_KEYS.DICH_VU
  },
  [QUERY_KEYS.NGAN_HANG]: {
    importForm: () => import('@/features/danh-muc/ngan-hang/danh-muc-ngan-hang/components/FormDialog'),
    endpoint: QUERY_KEYS.NGAN_HANG
  },
  [QUERY_KEYS.TAI_KHOAN_NGAN_HANG]: {
    importForm: () => import('@/features/danh-muc/ngan-hang/tai-khoan-ngan-hang/components/form-dialog'),
    endpoint: QUERY_KEYS.TAI_KHOAN_NGAN_HANG
  },
  [QUERY_KEYS.KHO_HANG]: {
    importForm: () => import('@/features/danh-muc/vat-tu-san-pham-va-kho/kho-hang/components/FormDialog'),
    endpoint: QUERY_KEYS.KHO_HANG
  },
  [QUERY_KEYS.BO_PHAN]: {
    importForm: () => import('@/features/danh-muc/doi-tuong/bo-phan-ke-toan/components/form-dialog'),
    endpoint: QUERY_KEYS.BO_PHAN
  },
  [QUERY_KEYS.VAT_TU]: {
    importForm: () => import('@/features/danh-muc/vat-tu-san-pham-va-kho/vat-tu-san-pham/components/form-dialog'),
    endpoint: QUERY_KEYS.VAT_TU
  },
  [QUERY_KEYS.TAI_KHOAN]: {
    importForm: () => import('@/features/danh-muc/doi-tuong/he-thong-tai-khoan/components/FormDialogWrapper'),
    endpoint: QUERY_KEYS.TAI_KHOAN
  },
  [QUERY_KEYS.TAI_KHOAN_ALL]: {
    importForm: () => import('@/features/danh-muc/doi-tuong/he-thong-tai-khoan/components/FormDialogWrapper'),
    endpoint: QUERY_KEYS.TAI_KHOAN_ALL
  },
  [QUERY_KEYS.NHOM_THUE]: {
    importForm: () => import('@/features/danh-muc/thue/nhom-thue/components/FormDialog'),
    endpoint: QUERY_KEYS.NHOM_THUE
  },
  'groups?loai_nhom=TAX': {
    importForm: () => import('@/features/danh-muc/thue/nhom-thue/components/FormDialog'),
    endpoint: 'groups?loai_nhom=TAX'
  },
  [QUERY_KEYS.DON_VI_TINH]: {
    importForm: () => import('@/features/danh-muc/khai-bao-kho-vat-tu/don-vi-tinh/components/unit-dialog'),
    endpoint: QUERY_KEYS.DON_VI_TINH
  }
};
